export function isNotNullOrWhitespace(param) {
  if (param !== null && param !== undefined && param !== '') {
    return true;
  } else {
    return false;
  }
}

export function isNotNull(param) {
  if (param !== null && param !== undefined) {
    return true;
  } else {
    return false;
  }
}

export function isNotNullOrEmptyArray(param) {
  if (param !== null && param !== undefined ) {
    if (param.length > 0) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function isNotEmptyObject(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop))
      return true;
  }
  return JSON.stringify(obj) !== JSON.stringify({});
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}